import React from 'react'
import PayPalNavigation from 'components/common/paypal_navigation'
import Footer from 'marketing-components/dist/components/organisms/footer'

const RenderFooter = () => {
  const footer = document.getElementById('data-footer')?.innerHTML
  if (footer) {
    try {
      const {
        content: { content: footerContent, config = {} },
      } = JSON.parse(footer)
      const { localeCountry } = footerContent

      return (
        <Footer
          config={config}
          content={footerContent}
          localeCountry={localeCountry}
        />
      )
    } catch (error) {
      return <PayPalNavigation element="footerHtml" />
    }
  } else {
    return <PayPalNavigation element="footerHtml" />
  }
}

export default RenderFooter
